import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/homeData';
import { articles } from '@/mocks/articleData';

export default function LatestUpdate() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-foreground-900">
                最新更新
              </h2>
              <Link
                to="/category/drama"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {latestUpdates.map((item) => (
                <Link
                  key={item.id}
                  to={`/category/${item.category}`}
                  className="group bg-white rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300"
                >
                  <div className="aspect-video overflow-hidden relative">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                      title={`${item.title} - 日本在线观看`}
                    />
                    <div className="absolute top-2 left-2">
                      <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-md">
                        {item.categoryName}
                      </span>
                    </div>
                    <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded-md">
                      {item.episode}
                    </div>
                  </div>
                  <div className="p-3">
                    <h3 className="font-serif font-semibold text-foreground-900 text-sm mb-1 line-clamp-1">
                      {item.title}
                    </h3>
                    <p className="text-xs text-foreground-400">{item.updateTime}更新</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-foreground-900">
                影视资讯
              </h2>
              <Link
                to="/articles"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
              >
                更多 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="space-y-4">
              {articles.slice(0, 4).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group flex gap-3 p-3 rounded-xl bg-white hover:bg-background-100 transition-all duration-300"
                >
                  <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                      title={`${article.title} - 日本在线观看 影视资讯`}
                    />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-medium text-foreground-900 text-sm line-clamp-2 mb-1 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-2 text-xs text-foreground-400">
                      <span>{article.publishDate}</span>
                      <span>·</span>
                      <span>{article.readCount.toLocaleString()} 阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}